import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./ReducerCombiner";

const store = configureStore({
    reducer: rootReducer
})

export default store;